/**
 * Feature flags.
 *
 * `messaging` covers the chat surfaces — the unified inbox and the social
 * People screen — which only the deferred account-based channels use. They are
 * off, and they stay in the repository: the model and the screens are what
 * LinkedIn, WhatsApp and Telegram land in, and deleting them means rebuilding
 * them within months. See
 * [decision 0005](../../../../docs/decisions/0005-launch-on-official-apis.md).
 *
 * Off means off everywhere, not just hidden: the nav omits the items, the
 * command palette omits the conversations, the routes answer not-found, and the
 * screenshot suite never reaches them. A flag that only hides the link is a
 * screenshot of a deferred channel waiting to happen.
 *
 * `VITE_FEATURE_MESSAGING=true` turns it on locally, for designing the
 * deferred screens without a branch.
 */
export const features = {
  messaging: import.meta.env.VITE_FEATURE_MESSAGING === "true",
} as const;
